import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../layout'),
    redirect: '/busqueda-del-predio',
    children: [
      {
        path: '/busqueda-del-predio',
        name: 'busqueda-del-predio',
        component: () => import('../views/busquedaDelPredio.vue'),
        meta: {
          title: 'Busqueda del predio',
        },
      },
      {
        path: '/recibo-de-pago',
        name: 'recibo-de-pago',
        component: () => import('../views/reciboDePago.vue'),
        meta: {
          title: 'Recibo de pago',
        },
      },
      {
        path: '/resumen-de-adeudo',
        name: 'resumen-de-adeudo',
        component: () => import('../views/resumenDeAdeudos.vue'),
        meta: {
          title: 'Resumen de adeudo',
        },
      },
      {
        path: '/requisitos-para-descuentos-especiales',
        name: 'requisitos-para-descuentos-especiales',
        component: () => import('../views/requerimientos.vue'),
        meta: {
          title: 'Requisitos para descuentos especiales',
        },
      },
      {
        path: '/detalles-de-pago',
        name: 'detalles-de-pago',
        component: () => import('../views/detallesdepago.vue'),
        meta: {
          title: 'Detalles de pago',
        },
      },
      {
        path: '/estado-de-cuenta',
        name: 'estado-de-cuenta',
        component: () => import('../views/estadoDeCuenta.vue'),
        meta: {
          title: 'Estado de cuenta',
        },
      },
      {
        path: '/pagar',
        name: 'pagar',
        component: () => import('../views/pagoPredial.vue'),
        meta: {
          title: 'Pagar',
        },
      },
      {
        path: '/pagar-constancia',
        name: 'pagar-constanciade no adeudo',
        component: () => import('../views/pagoCertificado.vue'),
        meta: {
          title: 'Pagar constanciade no adeudo',
        },
      },
      {
        path: '/confirmacion-pago-con-bancomer',
        name: 'confirmacion-pago-con-bancomer',
        component: () => import('../views/confirmacion.vue'),
        meta: {
          title: 'Confirmacion pago con bancomer',
        },
      },
      {
        path: '/confirmacion-pago-con-santander',
        name: 'confirmacion-pago-con-santander',
        component: () => import('../views/confirmacionWPP.vue'),
        meta: {
          title: 'Confirmacion pago WPP',
        },
      },
      {
        path: '/movil/referencia-de-pago',
        name: 'movil-referencia-de-pago',
        component: () => import('../views/movil/referenciasDePago.vue'),
        meta: {
          title: 'Movil referencia de pago',
        },
      },
      {
        path: '/movil/referencia-bancaria',
        name: 'movil-referencia-bancaria',
        component: () => import('../views/movil/referenciaBancaria.vue'),
        meta: {
          title: 'Movil referencia bancaria',
        },
      },
      {
        path: '/movil/referencia-oxxo',
        name: 'movil-referencia-oxxo',
        component: () => import('../views/movil/referenciaOXXO.vue'),
        meta: {
          title: 'Movil referencia oxxo',
        },
      },
      {
        path: '/movil/referencia-oxxo/qr',
        name: 'movil-referencia-oxxo-qr',
        component: () => import('../views/movil/qrOXXO.vue'),
        meta: {
          title: 'Movil referencia oxxo qr',
        },
      },
      {
        path: '/movil/referencia-oxxo/barcode',
        name: 'movil-referencia-oxxo-barcode',
        component: () => import('../views/movil/barcodeOXXO.vue'),
        meta: {
          title: 'Movil referencia oxxo barcode',
        },
      },
      {
        path: '/cobro-de-avaluos',
        name: 'Cobro de Avaluos',
        component: () => import('../views/cobroDeAvaluos.vue'),
        meta: {
          title: 'Cobro de avaluos',
        },
      },
      {
        path: '/pagar-avaluos',
        name: 'Pagar Avaluos',
        component: () => import('../views/pagoAvaluos.vue'),
        meta: {
          title: 'Pago de avaluos',
        },
      },
      {
        path: '/recibos-avaluos',
        name: 'Recibos Avaluos',
        component: () => import('../views/recibosAvaluos.vue'),
        meta: {
          title: 'Recibos',
        },
      },
      {
        path: '/recibo-pdf',
        name: 'Recibo',
        component: () => import('../views/reciboPDF.vue'),
        meta: {
          title: 'Recibo',
        },
      },
      {
        path: '/continuar-pago',
        name: 'Pago',
        component: () => import('../views/continuarPago.vue'),
        meta: {
          title: 'Pago de predial',
        },
      },
      {
        path: '/recibo-externo',
        beforeEnter(to, from, next) {
          window.location.href = 'https://pagos.zapopan.gob.mx/PortalCiudadano/Recaudacion/RecaudoPredial.aspx';
        },
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  routes,
});

export default router;
